import Questionnaire from "../sections/Questionnaire";

const icons = [
  {
    title: "Im Haus",
    // TODO eventuell beschreibung das hier im Haus unter der Rückstaueben gemeint ist
    link: "im-haus",
    imgUrl: "/content/uploads/2018/08/haus.png"
  },
  {
    title: "vorhandener Schacht",
    externalLink: "/berater",
    imgUrl: "/content/uploads/2018/08/loch.png"
  },
  {
    title: "Komplett + Schacht",
    externalLink: "/berater",
    imgUrl: "/content/uploads/2018/08/loch.png"
  }
]

export function Abwasser() {

  return (
    <Questionnaire question={"Wo soll die Pumpe arbeiten?"} icons={icons} />
  );
}